import { render, staticRenderFns } from "./NotCodInSheme.vue?vue&type=template&id=35b351d8&scoped=true&"
import script from "./NotCodInSheme.vue?vue&type=script&lang=js&"
export * from "./NotCodInSheme.vue?vue&type=script&lang=js&"
import style0 from "./NotCodInSheme.vue?vue&type=style&index=0&id=35b351d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b351d8",
  null
  
)

export default component.exports